
import Vue from 'vue';
import EuCard from '../Card/Card.vue';
import ArrowRight from '../../../Icons/ArrowRightLight.vue';
/**
- To show content below, pass prop <b>leftText / rightText</b>
- Pass the card <b>elevation</b> prop to set the card's elevation type
- Pass the prop <b>withArrow</b> to show arrow
- To modify image size, use class <b>.eu-generalinfotext-image</b>
- Customizable header with slot `header`
**/
export default Vue.extend<any, any, any, any>({
  name: 'GeneralInfoTextCard',
  components: {
    EuCard,
    ArrowRight
  },
  props: {
    /**
     * Set id
     */
    id: {
      type: [Number, String],
      default: ''
    },
    /**
     * Set Card elevation type
     */
    elevation: {
      type: String,
      default: 'flat'
    },
    /**
     * Set title
     */
    title: {
      type: String,
      default: ''
    },
    /**
     * Set text on left side
     */
    leftText: {
      type: String,
      default: ''
    },
    /**
     * Set text on right side
     */
    rightText: {
      type: String,
      default: ''
    },
    /**
     * Set card with arrow on right side
     */
    withArrow: {
      type: Boolean,
      default: false
    },
    /**
     * Set custom content
     */
    customContent: {
      type: Boolean,
      default: false
    },
    /**
     * Set image
     */
    image: {
      type: String,
      default: ''
    },
    /**
     * Set info card on selected view
     */
    selected: {
      type: Boolean,
      default: false
    },
    /**
     * Set info action icon (arrow/tick)
     */
    actionIcon: {
      type: [String, Object],
      default: () => ArrowRight
    },
    /**
     * Set icon color
     */
    actionIconColor: {
      type: String,
      default: '#ff6400'
    },
    /**
     * Set card to disabled state
     */
    disabled: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleClick(e: any) {
      if (!this.disabled) {
        /**
         * Method to click arrow
         *  @event click
         * @type {function}
         */
        this.$emit('click', e);
      }
    },
    handleClickCard(e: any) {
      if (!this.disabled) {
        /**
         * Method to click card
         * @event click-card
         * @type {function}
         */
        this.$emit('click-card', e);
      }
    }
  }
});
